function handleFocusIn(event) {
    if (event.target.matches("input[list]")) {
        const input = event.target;
        const currentValue = input.value;
        if (currentValue) {
            requestAnimationFrame(() => {
                if (document.activeElement === input) {
                    const end = input.value.length;
                    input.setSelectionRange(end, end);
                }
            });
        }
    }
}

function handleInput(event) {
    if (event.target.matches("input[list]")) {
        event.target.dataset.scriptCleared = "false";
    }
}

function handleFocusOut(event) {
    if (event.target.matches("input[list]")) {
        delete event.target.dataset.originalValue;
        delete event.target.dataset.scriptCleared;
    }
}

function handleKeyDown(event) {
    if (!event.target.matches("input[list]")) return;
}

function handleMouseDown(event) {
    if (!event.target.matches("input[list]")) return;
}

export function initDatalistHandlers() {
    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("input", handleInput);
    document.addEventListener("focusout", handleFocusOut);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleMouseDown);
}
